import { useState } from 'react'
import { Box } from '@mui/material'
import { Business as AccountsIcon } from '@mui/icons-material'
import { PageHeader } from '../components/shared/PageHeader'
import { AccountList } from '../features/accounts/AccountList'
import { AccountForm } from '../features/accounts/AccountForm'
import { useQuery } from '@tanstack/react-query'
import { accountsApi } from '../lib/api/accountsApi'

export default function AccountsPage() {
  const [showForm, setShowForm] = useState(false)
  const { data: accounts = [], isLoading } = useQuery({
    queryKey: ['accounts'],
    queryFn: () => accountsApi.getAll(),
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <PageHeader
        title="Accounts"
      />
      <AccountList
        accounts={accounts}
        isLoading={isLoading}
        onNewClick={() => setShowForm(true)}
        onSearch={() => {}}
      />
      <AccountForm open={showForm} onClose={() => setShowForm(false)} onSubmit={(data) => { accountsApi.create(data); setShowForm(false) }} />
    </Box>
  )
}
